import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as t } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const l = t((a, e) => /* @__PURE__ */ s.jsx(
  i,
  {
    ref: e,
    ...a,
    image: (r) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...r,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_3632",
              width: 16,
              height: 16,
              x: 0,
              y: 0,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  fill: "currentColor",
                  d: "M12.81 12.46c.12.12.29.2.46.22l1.75.16h.07a.753.753 0 0 0 .75-.82l-.16-1.75a.74.74 0 0 0-.22-.46L5.87.22a.754.754 0 0 0-1.06 0L3.23 1.8c-.29.29-.29.77 0 1.06zm.24-2.94-.52.53-5.94-5.94.52-.52zm.63 1.68-.1-.1.52-.53.1.1.05.58zM5.34 1.81l.71.71-.52.53-.71-.72zM15.24 14.49H.75c-.41 0-.75.34-.75.75s.34.75.75.75h14.49c.41 0 .75-.34.75-.75s-.34-.75-.75-.75"
                }
              )
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_3632)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) })
        ]
      }
    )
  }
));
l.displayName = "AgencyEditIcon";
export {
  l as AgencyEditIcon,
  l as default
};
//# sourceMappingURL=index.js.map
